import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'maxZIndex' })
export class MaxZIndexPipe implements PipeTransform {
  transform(selector: string, defaultValue = 0): number {
    const elements = document.querySelectorAll(selector);
    let maxZIndex = 0;
    let hasNumericZIndex = false;

    elements.forEach((element) => {
      const zIndex = window.getComputedStyle(element).zIndex;
      if (zIndex !== 'auto') {
        hasNumericZIndex = true;
        maxZIndex = Math.max(maxZIndex, parseInt(zIndex, 10));
      }
    });

    return hasNumericZIndex ? maxZIndex + 1 : defaultValue;
  }
}
